import { AuditLogMaintenanceConstant } from "presentation/constant/AuditLog/AuditLogMaintenanceConstant";
import { useAuditLogMaintenanceVM } from "presentation/hook/AuditLog/useAuditLogMaintenanceVM";
import { useAuditLogMaintenanceTracked } from "presentation/store/AuditLog/AuditLogMaintenanceProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DatePickerComponent from "presentation/view/components/DatePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NbisDateTimePickerComponent from "presentation/view/components/NbisDateTimePickerComponent";
import { memo, useCallback, useMemo } from "react";
import { FieldType, HPHBreadcrumb, IconButton, IFieldValue } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, Sidebarheader, StyledAction, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const AuditLogDetailPanel = () => {
    const SCREEN_CONSTANT = AuditLogMaintenanceConstant;
    const [auditLogState] = useAuditLogMaintenanceTracked();
    const auditLogVM = useAuditLogMaintenanceVM();
    const { currentEntity } = auditLogState;

    const memoCntrNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.cntrNo ?? ''}
                fieldValue={currentEntity?.cntrNo}
                fieldLabel={SCREEN_CONSTANT.CNTR_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'cntrNo'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CNTR_NO, auditLogVM, currentEntity?.cntrNo])

    const memoSubChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.subChargeType ?? ''}
                fieldValue={currentEntity?.subChargeType}
                fieldLabel={SCREEN_CONSTANT.SUB_CHARGE_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'subChargeType'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SUB_CHARGE_TYPE, auditLogVM, currentEntity?.subChargeType])

    const memoChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.chargeType ?? ''}
                fieldValue={currentEntity?.chargeType}
                fieldLabel={SCREEN_CONSTANT.CHARGE_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'chargeType'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CHARGE_TYPE, auditLogVM, currentEntity?.chargeType])

    const memoUpdatedDateTime = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisDateTimePickerComponent
                disabled={true}
                label={SCREEN_CONSTANT.UPDATED_DATE}
                width="260px"
                date={currentEntity?.updatedDateTime ?? null}
                fieldName="updatedDateTime"
                onDateChange={(fieldKey: string, fieldValue: IFieldValue) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue)} />
        </div>
        , [SCREEN_CONSTANT.UPDATED_DATE, auditLogVM, currentEntity?.updatedDateTime])

    const memoOpsLine = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.opsLine ?? ''}
                fieldValue={currentEntity?.opsLine}
                fieldLabel={SCREEN_CONSTANT.OPS_LINE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'opsLine'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.OPS_LINE, auditLogVM, currentEntity?.opsLine])

    const memoProposalNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.proposalNo ?? ''}
                fieldValue={currentEntity?.proposalNo}
                fieldLabel={SCREEN_CONSTANT.PROPOSAL_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'proposalNo'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.PROPOSAL_NO, auditLogVM, currentEntity?.proposalNo])

    const memoUserId = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.userId ?? ''}
                fieldValue={currentEntity?.userId}
                fieldLabel={SCREEN_CONSTANT.USER_ID}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'userId'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.USER_ID, auditLogVM, currentEntity?.userId])

    const memoBillOfLading = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.billOfLading ?? ''}
                fieldValue={currentEntity?.billOfLading}
                fieldLabel={SCREEN_CONSTANT.BILL_OF_LADING}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'billOfLading'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.BILL_OF_LADING, auditLogVM, currentEntity?.billOfLading])

    const memoShippingBill = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.shippingBill ?? ''}
                fieldValue={currentEntity?.shippingBill}
                fieldLabel={SCREEN_CONSTANT.SHIPPING_BILL}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'shippingBill'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SHIPPING_BILL, auditLogVM, currentEntity?.shippingBill])

    const memoForwarderCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.forwarderCode ?? ''}
                fieldValue={currentEntity?.forwarderCode}
                fieldLabel={SCREEN_CONSTANT.FORWARDER_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'forwarderCode'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.FORWARDER_CODE, auditLogVM, currentEntity?.forwarderCode])

    const memoDtlStateBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.dtlStateBf ?? ''}
                fieldValue={currentEntity?.dtlStateBf}
                fieldLabel={SCREEN_CONSTANT.DTL_STATE_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'dtlStateBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.DTL_STATE_BF, auditLogVM, currentEntity?.dtlStateBf])

    const memoDtlStateAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.dtlStateAf ?? ''}
                fieldValue={currentEntity?.dtlStateAf}
                fieldLabel={SCREEN_CONSTANT.DTL_STATE_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'dtlStateAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.DTL_STATE_AF, auditLogVM, currentEntity?.dtlStateAf])

    const memoBillToCompanyBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.billToCompanyBf ?? ''}
                fieldValue={currentEntity?.billToCompanyBf}
                fieldLabel={SCREEN_CONSTANT.BILL_TO_COMPANY_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'billToCompanyBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.BILL_TO_COMPANY_BF, auditLogVM, currentEntity?.billToCompanyBf])

    const memoBillToCompanyAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.billToCompanyAf ?? ''}
                fieldValue={currentEntity?.billToCompanyAf}
                fieldLabel={SCREEN_CONSTANT.BILL_TO_COMPANY_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'billToCompanyAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.BILL_TO_COMPANY_AF, auditLogVM, currentEntity?.billToCompanyAf])

    const memoChargeOnCompanyBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.chargeOnCompanyBf ?? ''}
                fieldValue={currentEntity?.chargeOnCompanyBf}
                fieldLabel={SCREEN_CONSTANT.CHARGE_ON_COMPANY_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'chargeOnCompanyBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CHARGE_ON_COMPANY_BF, auditLogVM, currentEntity?.chargeOnCompanyBf])

    const memoChargeOnCompanyAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.chargeOnCompanyAf ?? ''}
                fieldValue={currentEntity?.chargeOnCompanyAf}
                fieldLabel={SCREEN_CONSTANT.CHARGE_ON_COMPANY_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'chargeOnCompanyAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CHARGE_ON_COMPANY_AF, auditLogVM, currentEntity?.chargeOnCompanyAf])

    const memoDraftDocNoBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.draftDocNoBf ?? ''}
                fieldValue={currentEntity?.draftDocNoBf}
                fieldLabel={SCREEN_CONSTANT.DRAFT_DOC_NO_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'draftDocNoBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.DRAFT_DOC_NO_BF, auditLogVM, currentEntity?.draftDocNoBf])

    const memoDraftDocNoAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.draftDocNoAf ?? ''}
                fieldValue={currentEntity?.draftDocNoAf}
                fieldLabel={SCREEN_CONSTANT.DRAFT_DOC_NO_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'draftDocNoAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.DRAFT_DOC_NO_AF, auditLogVM, currentEntity?.draftDocNoAf])

    const memoDocNoBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.docNoBf ?? ''}
                fieldValue={currentEntity?.docNoBf}
                fieldLabel={SCREEN_CONSTANT.DOC_NO_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'docNoBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.DOC_NO_BF, auditLogVM, currentEntity?.docNoBf])

    const memoDocNoAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.docNoAf ?? ''}
                fieldValue={currentEntity?.docNoAf}
                fieldLabel={SCREEN_CONSTANT.DOC_NO_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'docNoAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.DOC_NO_AF, auditLogVM, currentEntity?.docNoAf])

    const memoReceiptNoBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.receiptNoBf ?? ''}
                fieldValue={currentEntity?.receiptNoBf}
                fieldLabel={SCREEN_CONSTANT.RECEIPT_NO_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'receiptNoBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.RECEIPT_NO_BF, auditLogVM, currentEntity?.receiptNoBf])

    const memoReceiptNoAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.receiptNoAf ?? ''}
                fieldValue={currentEntity?.receiptNoAf}
                fieldLabel={SCREEN_CONSTANT.RECEIPT_NO_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'receiptNoAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.RECEIPT_NO_AF, auditLogVM, currentEntity?.receiptNoAf])

    const memoConsortiumCodeAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.consortiumCodeAf ?? ''}
                fieldValue={currentEntity?.consortiumCodeAf}
                fieldLabel={SCREEN_CONSTANT.CONSORTIUM_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'consortiumCodeAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CONSORTIUM_CODE, auditLogVM, currentEntity?.consortiumCodeAf])

    const memoVesselCodeAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.vesselCodeAf ?? ''}
                fieldValue={currentEntity?.vesselCodeAf}
                fieldLabel={SCREEN_CONSTANT.VESSEL_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'vesselCodeAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.VESSEL_CODE, auditLogVM, currentEntity?.vesselCodeAf])

    const memoVoyageCodeAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.voyageCodeAf ?? ''}
                fieldValue={currentEntity?.voyageCodeAf}
                fieldLabel={SCREEN_CONSTANT.VOYAGE_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'voyageCodeAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.VOYAGE_CODE, auditLogVM, currentEntity?.voyageCodeAf])

    const memoFspCalculateMethodAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.fspCalculateMethodAf ?? ''}
                fieldValue={currentEntity?.fspCalculateMethodAf}
                fieldLabel={SCREEN_CONSTANT.VOYAGE_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'fspCalculateMethodAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.VOYAGE_CODE, auditLogVM, currentEntity?.fspCalculateMethodAf])

    const memoCompanyCodeBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.companyCodeBf ?? ''}
                fieldValue={currentEntity?.companyCodeBf}
                fieldLabel={SCREEN_CONSTANT.COMPANY_CODE_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'companyCodeBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.COMPANY_CODE_BF, auditLogVM, currentEntity?.companyCodeBf])

    const memoCompanyCodeAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.companyCodeAf ?? ''}
                fieldValue={currentEntity?.companyCodeAf}
                fieldLabel={SCREEN_CONSTANT.COMPANY_CODE_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'companyCodeAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.COMPANY_CODE_AF, auditLogVM, currentEntity?.companyCodeAf])

    const memoPriorityBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.priorityBf?.toString() ?? ''}
                fieldValue={currentEntity?.priorityBf}
                fieldLabel={SCREEN_CONSTANT.PRIORITY_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'priorityBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.PRIORITY_BF, auditLogVM, currentEntity?.priorityBf])

    const memoPriorityAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.priorityAf?.toString() ?? ''}
                fieldValue={currentEntity?.priorityAf}
                fieldLabel={SCREEN_CONSTANT.PRIORITY_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'priorityAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.PRIORITY_AF, auditLogVM, currentEntity?.priorityAf])

    const memoStatusBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.statusBf ?? ''}
                fieldValue={currentEntity?.statusBf}
                fieldLabel={SCREEN_CONSTANT.STATUS_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'statusBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.STATUS_BF, auditLogVM, currentEntity?.statusBf])

    const memoStatusAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.statusAf ?? ''}
                fieldValue={currentEntity?.statusAf}
                fieldLabel={SCREEN_CONSTANT.STATUS_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'statusAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.STATUS_AF, auditLogVM, currentEntity?.statusAf])

    const memoOwnerBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.ownerBf ?? ''}
                fieldValue={currentEntity?.ownerBf}
                fieldLabel={SCREEN_CONSTANT.SHIPPING_LINE_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'ownerBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SHIPPING_LINE_BF, auditLogVM, currentEntity?.ownerBf])

    const memoOwnerAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.ownerAf ?? ''}
                fieldValue={currentEntity?.ownerAf}
                fieldLabel={SCREEN_CONSTANT.SHIPPING_LINE_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'ownerAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SHIPPING_LINE_AF, auditLogVM, currentEntity?.ownerAf])

    const memoEffectiveDateFromBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <DatePickerComponent
                disabled={true}
                label={SCREEN_CONSTANT.EFFECTIVE_DATE_FROM_BF}
                width="260px"
                date={currentEntity?.effectiveDateFromBf ?? null}
                fieldName="effectiveDateFromBf"
                onDateChange={(fieldKey: string, fieldValue: IFieldValue) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue)} />
        </div>
        , [SCREEN_CONSTANT.EFFECTIVE_DATE_FROM_BF, auditLogVM, currentEntity?.effectiveDateFromBf])

    const memoEffectiveDateFromAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <DatePickerComponent
                disabled={true}
                label={SCREEN_CONSTANT.EFFECTIVE_DATE_FROM_AF}
                width="260px"
                date={currentEntity?.effectiveDateFromAf ?? null}
                fieldName="effectiveDateFromAf"
                onDateChange={(fieldKey: string, fieldValue: IFieldValue) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue)} />
        </div>
        , [SCREEN_CONSTANT.EFFECTIVE_DATE_FROM_AF, auditLogVM, currentEntity?.effectiveDateFromAf])

    const memoEffectiveDateToBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <DatePickerComponent
                disabled={true}
                label={SCREEN_CONSTANT.EFFECTIVE_DATE_TO_BF}
                width="260px"
                date={currentEntity?.effectiveDateToBf ?? null}
                fieldName="effectiveDateToBf"
                onDateChange={(fieldKey: string, fieldValue: IFieldValue) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue)} />
        </div>
        , [SCREEN_CONSTANT.EFFECTIVE_DATE_TO_BF, auditLogVM, currentEntity?.effectiveDateToBf])

    const memoEffectiveDateToAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <DatePickerComponent
                disabled={true}
                label={SCREEN_CONSTANT.EFFECTIVE_DATE_TO_AF}
                width="260px"
                date={currentEntity?.effectiveDateToAf ?? null}
                fieldName="effectiveDateToAf"
                onDateChange={(fieldKey: string, fieldValue: IFieldValue) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue)} />
        </div>
        , [SCREEN_CONSTANT.EFFECTIVE_DATE_TO_AF, auditLogVM, currentEntity?.effectiveDateToAf])

    const memoServiceCodeBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.serviceCodeBf ?? ''}
                fieldValue={currentEntity?.serviceCodeBf}
                fieldLabel={SCREEN_CONSTANT.SERVICE_CODE_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'serviceCodeBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SERVICE_CODE_BF, auditLogVM, currentEntity?.serviceCodeBf])

    const memoServiceCodeAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.serviceCodeAf ?? ''}
                fieldValue={currentEntity?.serviceCodeAf}
                fieldLabel={SCREEN_CONSTANT.SERVICE_CODE_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'serviceCodeAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SERVICE_CODE_AF, auditLogVM, currentEntity?.serviceCodeAf])

    const memoForwarderCodeBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.forwarderCodeBf ?? ''}
                fieldValue={currentEntity?.forwarderCodeBf}
                fieldLabel={SCREEN_CONSTANT.SERVICE_CODE_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'forwarderCodeBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SERVICE_CODE_AF, auditLogVM, currentEntity?.forwarderCodeBf])

    const memoForwarderCodeAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.forwarderCodeAf ?? ''}
                fieldValue={currentEntity?.forwarderCodeAf}
                fieldLabel={SCREEN_CONSTANT.FORWARDER_CODE_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'forwarderCodeAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.FORWARDER_CODE_BF, auditLogVM, currentEntity?.forwarderCodeAf])

    const memoAgentCodeBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.agentCodeBf ?? ''}
                fieldValue={currentEntity?.agentCodeBf}
                fieldLabel={SCREEN_CONSTANT.AGENT_CODE_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'agentCodeBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.AGENT_CODE_BF, auditLogVM, currentEntity?.agentCodeBf])

    const memoAgentCodeAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.agentCodeAf ?? ''}
                fieldValue={currentEntity?.agentCodeAf}
                fieldLabel={SCREEN_CONSTANT.AGENT_CODE_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'agentCodeAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.AGENT_CODE_AF, auditLogVM, currentEntity?.agentCodeAf])

    const memoCargoCodeBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.cargoCodeBf ?? ''}
                fieldValue={currentEntity?.cargoCodeBf}
                fieldLabel={SCREEN_CONSTANT.CARGO_CODE_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'cargoCodeBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CARGO_CODE_BF, auditLogVM, currentEntity?.cargoCodeBf])

    const memoCargoCodeAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.cargoCodeAf ?? ''}
                fieldValue={currentEntity?.cargoCodeAf}
                fieldLabel={SCREEN_CONSTANT.CARGO_CODE_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'cargoCodeAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CARGO_CODE_AF, auditLogVM, currentEntity?.cargoCodeAf])

    const memoFspCountingFromBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.fspCountingFromBf ?? ''}
                fieldValue={currentEntity?.fspCountingFromBf}
                fieldLabel={SCREEN_CONSTANT.FSP_COUNTING_FROM_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'fspCountingFromBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.FSP_COUNTING_FROM_BF, auditLogVM, currentEntity?.fspCountingFromBf])

    const memoFspCountingFromAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.fspCountingFromAf ?? ''}
                fieldValue={currentEntity?.fspCountingFromAf}
                fieldLabel={SCREEN_CONSTANT.FSP_COUNTING_FROM_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'fspCountingFromAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.FSP_COUNTING_FROM_AF, auditLogVM, currentEntity?.fspCountingFromAf])

    const memofspCountingToBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.fspCountingToBf ?? ''}
                fieldValue={currentEntity?.fspCountingToBf}
                fieldLabel={SCREEN_CONSTANT.FSP_COUNTING_TO_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'fspCountingToBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.FSP_COUNTING_TO_BF, auditLogVM, currentEntity?.fspCountingToBf])

    const memofspCountingToAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.fspCountingToAf ?? ''}
                fieldValue={currentEntity?.fspCountingToAf}
                fieldLabel={SCREEN_CONSTANT.FSP_COUNTING_TO_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'fspCountingToAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.FSP_COUNTING_TO_AF, auditLogVM, currentEntity?.fspCountingToAf])

    const memoGraceHourFromBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.graceHourFromBf?.toString() ?? ''}
                fieldValue={currentEntity?.graceHourFromBf}
                fieldLabel={SCREEN_CONSTANT.GRACE_HOUR_FROM_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'graceHourFromBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.GRACE_HOUR_FROM_BF, auditLogVM, currentEntity?.graceHourFromBf])

    const memoGraceHourFromAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.graceHourFromAf?.toString() ?? ''}
                fieldValue={currentEntity?.graceHourFromAf}
                fieldLabel={SCREEN_CONSTANT.GRACE_HOUR_FROM_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'graceHourFromAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.GRACE_HOUR_FROM_AF, auditLogVM, currentEntity?.graceHourFromAf])

    const memoGraceHourToBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.graceHourToBf?.toString() ?? ''}
                fieldValue={currentEntity?.graceHourToBf}
                fieldLabel={SCREEN_CONSTANT.GRACE_HOUR_TO_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'graceHourToBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.GRACE_HOUR_TO_BF, auditLogVM, currentEntity?.graceHourToBf])

    const memoGraceHourToAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.graceHourToAf?.toString() ?? ''}
                fieldValue={currentEntity?.graceHourToAf}
                fieldLabel={SCREEN_CONSTANT.GRACE_HOUR_TO_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'graceHourToAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.GRACE_HOUR_TO_AF, auditLogVM, currentEntity?.graceHourToAf])

    const memoGraceMinuteFromBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.graceMinuteFromBf?.toString() ?? ''}
                fieldValue={currentEntity?.graceMinuteFromBf}
                fieldLabel={SCREEN_CONSTANT.GRACE_MINUTE_FROM_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'graceMinuteFromBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.GRACE_MINUTE_FROM_BF, auditLogVM, currentEntity?.graceMinuteFromBf])

    const memoGraceMinuteFromAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.graceMinuteFromAf?.toString() ?? ''}
                fieldValue={currentEntity?.graceMinuteFromAf}
                fieldLabel={SCREEN_CONSTANT.GRACE_MINUTE_FROM_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'graceMinuteFromAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.GRACE_MINUTE_FROM_AF, auditLogVM, currentEntity?.graceMinuteFromAf])

    const memoGraceMinuteToBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.graceMinuteToBf?.toString() ?? ''}
                fieldValue={currentEntity?.graceMinuteToBf}
                fieldLabel={SCREEN_CONSTANT.GRACE_MINUTE_TO_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'graceMinuteToBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.GRACE_MINUTE_TO_BF, auditLogVM, currentEntity?.graceMinuteToBf])

    const memoGraceMinuteToAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.graceMinuteToAf?.toString() ?? ''}
                fieldValue={currentEntity?.graceMinuteToAf}
                fieldLabel={SCREEN_CONSTANT.GRACE_MINUTE_TO_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'graceMinuteToAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.GRACE_MINUTE_TO_AF, auditLogVM, currentEntity?.graceMinuteToAf])

    const memoShipmentTypeBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.shipmentTypeBf ?? ''}
                fieldValue={currentEntity?.shipmentTypeBf}
                fieldLabel={SCREEN_CONSTANT.SHIPMENT_TYPE_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'shipmentTypeBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SHIPMENT_TYPE_BF, auditLogVM, currentEntity?.shipmentTypeBf])

    const memoShipmentTypeAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.shipmentTypeAf ?? ''}
                fieldValue={currentEntity?.shipmentTypeAf}
                fieldLabel={SCREEN_CONSTANT.SHIPMENT_TYPE_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'shipmentTypeAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SHIPMENT_TYPE_AF, auditLogVM, currentEntity?.shipmentTypeAf])

    const memoFspCountingDirectionBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.fspCountingDirectionBf ?? ''}
                fieldValue={currentEntity?.fspCountingDirectionBf}
                fieldLabel={SCREEN_CONSTANT.FSP_COUNTING_DIRECTION_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'fspCountingDirectionBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.FSP_COUNTING_DIRECTION_BF, auditLogVM, currentEntity?.fspCountingDirectionBf])

    const memoFspCountingDirectionAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.fspCountingDirectionAf ?? ''}
                fieldValue={currentEntity?.fspCountingDirectionAf}
                fieldLabel={SCREEN_CONSTANT.FSP_COUNTING_DIRECTION_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'fspCountingDirectionAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.FSP_COUNTING_DIRECTION_AF, auditLogVM, currentEntity?.fspCountingDirectionAf])

    const memoFirstTierFspBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.firstTierFspBf?.toString() ?? ''}
                fieldValue={currentEntity?.firstTierFspBf}
                fieldLabel={SCREEN_CONSTANT.FSP_DAYS_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'firstTierFspBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.FSP_DAYS_BF, auditLogVM, currentEntity?.firstTierFspBf])

    const memoFirstTierFspAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.firstTierFspAf?.toString() ?? ''}
                fieldValue={currentEntity?.firstTierFspAf}
                fieldLabel={SCREEN_CONSTANT.FSP_DAYS_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'firstTierFspAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.FSP_DAYS_AF, auditLogVM, currentEntity?.firstTierFspAf])

    const memoFspUomBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.fspUomBf ?? ''}
                fieldValue={currentEntity?.fspUomBf}
                fieldLabel={SCREEN_CONSTANT.FSP_UOM_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'fspUomBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.FSP_UOM_BF, auditLogVM, currentEntity?.fspUomBf])

    const memoFspUomAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.fspUomAf ?? ''}
                fieldValue={currentEntity?.fspUomAf}
                fieldLabel={SCREEN_CONSTANT.FSP_UOM_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'fspUomAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.FSP_UOM_AF, auditLogVM, currentEntity?.fspUomAf])

    const memoChargeTypeBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.chargeTypeBf ?? ''}
                fieldValue={currentEntity?.chargeTypeBf}
                fieldLabel={SCREEN_CONSTANT.CHARGE_TYPE_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'chargeTypeBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CHARGE_TYPE_BF, auditLogVM, currentEntity?.chargeTypeBf])

    const memoChargeTypeAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.chargeTypeAf ?? ''}
                fieldValue={currentEntity?.chargeTypeAf}
                fieldLabel={SCREEN_CONSTANT.CHARGE_TYPE_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'chargeTypeAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CHARGE_TYPE_AF, auditLogVM, currentEntity?.chargeTypeAf])

    const memoSubChargeTypeBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.subChargeTypeBf ?? ''}
                fieldValue={currentEntity?.subChargeTypeBf}
                fieldLabel={SCREEN_CONSTANT.SUB_CHARGE_TYPE_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'subChargeTypeBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SUB_CHARGE_TYPE_BF, auditLogVM, currentEntity?.subChargeTypeBf])

    const memoSubChargeTypeAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.subChargeTypeAf ?? ''}
                fieldValue={currentEntity?.subChargeTypeAf}
                fieldLabel={SCREEN_CONSTANT.SUB_CHARGE_TYPE_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'subChargeTypeAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SUB_CHARGE_TYPE_AF, auditLogVM, currentEntity?.subChargeTypeAf])

    const memoCntrMovementBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.cntrMovementBf ?? ''}
                fieldValue={currentEntity?.cntrMovementBf}
                fieldLabel={SCREEN_CONSTANT.CNTR_MOVEMENT_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'cntrMovementBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CNTR_MOVEMENT_BF, auditLogVM, currentEntity?.cntrMovementBf])

    const memoCntrMovementAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.cntrMovementAf ?? ''}
                fieldValue={currentEntity?.cntrMovementAf}
                fieldLabel={SCREEN_CONSTANT.CNTR_MOVEMENT_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'cntrMovementAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CNTR_MOVEMENT_AF, auditLogVM, currentEntity?.cntrMovementAf])

    const memoCntrStatusBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.cntrStatusBf ?? ''}
                fieldValue={currentEntity?.cntrStatusBf}
                fieldLabel={SCREEN_CONSTANT.CNTR_STATUS_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'cntrStatusBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CNTR_STATUS_BF, auditLogVM, currentEntity?.cntrStatusBf])

    const memoCntrStatusAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.cntrStatusAf ?? ''}
                fieldValue={currentEntity?.cntrStatusAf}
                fieldLabel={SCREEN_CONSTANT.CNTR_STATUS_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'cntrStatusAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CNTR_STATUS_AF, auditLogVM, currentEntity?.cntrStatusAf])

    const memoCustomerTypeBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.customerTypeBf ?? ''}
                fieldValue={currentEntity?.customerTypeBf}
                fieldLabel={SCREEN_CONSTANT.CUSTOMER_TYPE_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'customerTypeBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CUSTOMER_TYPE_BF, auditLogVM, currentEntity?.customerTypeBf])

    const memoCustomerTypeAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.customerTypeAf ?? ''}
                fieldValue={currentEntity?.customerTypeAf}
                fieldLabel={SCREEN_CONSTANT.CUSTOMER_TYPE_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'customerTypeAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CUSTOMER_TYPE_AF, auditLogVM, currentEntity?.customerTypeAf])

    const memoForwarderReferenceBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.forwarderReferenceBf ?? ''}
                fieldValue={currentEntity?.forwarderReferenceBf}
                fieldLabel={SCREEN_CONSTANT.FORWARDER_REF_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'forwarderReferenceBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.FORWARDER_REF_BF, auditLogVM, currentEntity?.forwarderReferenceBf])

    const memoForwarderReferenceAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.forwarderReferenceAf ?? ''}
                fieldValue={currentEntity?.forwarderReferenceAf}
                fieldLabel={SCREEN_CONSTANT.FORWARDER_REF_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'forwarderReferenceAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.FORWARDER_REF_AF, auditLogVM, currentEntity?.forwarderReferenceAf])

    const memoApplyCalendarAdjBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.applyCalendarAdjBf ?? ''}
                fieldValue={currentEntity?.applyCalendarAdjBf}
                fieldLabel={SCREEN_CONSTANT.APPLY_CALENDAR_ADJ_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'applyCalendarAdjBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.APPLY_CALENDAR_ADJ_BF, auditLogVM, currentEntity?.applyCalendarAdjBf])

    const memoApplyCalendarAdjAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.applyCalendarAdjAf ?? ''}
                fieldValue={currentEntity?.applyCalendarAdjAf}
                fieldLabel={SCREEN_CONSTANT.APPLY_CALENDAR_ADJ_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'applyCalendarAdjAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.APPLY_CALENDAR_ADJ_AF, auditLogVM, currentEntity?.applyCalendarAdjAf])

    const memoSplitFirstDaysBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.splitFirstDaysBf?.toString() ?? ''}
                fieldValue={currentEntity?.splitFirstDaysBf}
                fieldLabel={SCREEN_CONSTANT.SPLIT_FIRST_DAYS_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'splitFirstDaysBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SPLIT_FIRST_DAYS_BF, auditLogVM, currentEntity?.splitFirstDaysBf])

    const memoSplitFirstDaysAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.splitFirstDaysAf?.toString() ?? ''}
                fieldValue={currentEntity?.splitFirstDaysAf}
                fieldLabel={SCREEN_CONSTANT.SPLIT_FIRST_DAYS_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'splitFirstDaysAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SPLIT_FIRST_DAYS_AF, auditLogVM, currentEntity?.splitFirstDaysAf])


    const memoSplitFirstDaysToBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.splitFirstDaysToBf?.toString() ?? ''}
                fieldValue={currentEntity?.splitFirstDaysToBf}
                fieldLabel={SCREEN_CONSTANT.SPLIT_FIRST_DAYS_TO_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'splitFirstDaysToBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SPLIT_FIRST_DAYS_TO_BF, auditLogVM, currentEntity?.splitFirstDaysToBf])

    const memoSplitFirstDaysToAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.splitFirstDaysToAf?.toString() ?? ''}
                fieldValue={currentEntity?.splitFirstDaysToAf}
                fieldLabel={SCREEN_CONSTANT.SPLIT_FIRST_DAYS_TO_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'splitFirstDaysToAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SPLIT_FIRST_DAYS_TO_AF, auditLogVM, currentEntity?.splitFirstDaysToAf])

    const memoSplitRemainDaysToBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.splitRemainDaysToBf?.toString() ?? ''}
                fieldValue={currentEntity?.splitRemainDaysToBf}
                fieldLabel={SCREEN_CONSTANT.SPLIT_REMAIN_DAYS_TO_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'splitRemainDaysToBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SPLIT_REMAIN_DAYS_TO_BF, auditLogVM, currentEntity?.splitRemainDaysToBf])

    const memoSplitRemainDaysToAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.splitRemainDaysToAf?.toString() ?? ''}
                fieldValue={currentEntity?.splitRemainDaysToAf}
                fieldLabel={SCREEN_CONSTANT.SPLIT_REMAIN_DAYS_TO_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'splitRemainDaysToAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SPLIT_REMAIN_DAYS_TO_AF, auditLogVM, currentEntity?.splitRemainDaysToAf])

    const memoRejectReasonBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.rejectReasonBf?.toString() ?? ''}
                fieldValue={currentEntity?.rejectReasonBf}
                fieldLabel={SCREEN_CONSTANT.REJECT_REASON_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'rejectReasonBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.REJECT_REASON_BF, auditLogVM, currentEntity?.rejectReasonBf])

    const memoRejectReasonAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.rejectReasonAf?.toString() ?? ''}
                fieldValue={currentEntity?.rejectReasonAf}
                fieldLabel={SCREEN_CONSTANT.REJECT_REASON_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'rejectReasonAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.REJECT_REASON_AF, auditLogVM, currentEntity?.rejectReasonAf])

    const memoRemarksBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.remarksBf?.toString() ?? ''}
                fieldValue={currentEntity?.remarksBf}
                fieldLabel={SCREEN_CONSTANT.REMARKS_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'remarksBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.REMARKS_BF, auditLogVM, currentEntity?.remarksBf])


    const memoRemarksAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.remarksAf?.toString() ?? ''}
                fieldValue={currentEntity?.remarksAf}
                fieldLabel={SCREEN_CONSTANT.REMARKS_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'remarksAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.REMARKS_AF, auditLogVM, currentEntity?.remarksAf])

    const memoGraceExtendBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.graceExtendBf?.toString() ?? ''}
                fieldValue={currentEntity?.graceExtendBf}
                fieldLabel={SCREEN_CONSTANT.GRACE_EXTEND_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'graceExtendBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.GRACE_EXTEND_BF, auditLogVM, currentEntity?.graceExtendBf])

    const memoGraceExtendAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.graceExtendAf?.toString() ?? ''}
                fieldValue={currentEntity?.graceExtendAf}
                fieldLabel={SCREEN_CONSTANT.GRACE_EXTEND_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'graceExtendAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.GRACE_EXTEND_AF, auditLogVM, currentEntity?.graceExtendAf])

    const memoActiveIndBf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.activeIndBf?.toString() ?? ''}
                fieldValue={currentEntity?.activeIndBf}
                fieldLabel={SCREEN_CONSTANT.ACTIVE_IND_BF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'activeIndBf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.ACTIVE_IND_BF, auditLogVM, currentEntity?.activeIndBf])

    const memoActiveIndAf = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "420px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.activeIndAf?.toString() ?? ''}
                fieldValue={currentEntity?.activeIndAf}
                fieldLabel={SCREEN_CONSTANT.ACTIVE_IND_AF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'activeIndAf'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.ACTIVE_IND_AF, auditLogVM, currentEntity?.activeIndAf])

    const memoAuditLogIncident = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "1800px", marginBottom: "30px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEntity?.auditLogIncident ?? ''}
                fieldValue={currentEntity?.auditLogIncident}
                fieldLabel={SCREEN_CONSTANT.AUDIT_LOG_INCIDENT}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'auditLogIncident'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.AUDIT_LOG_INCIDENT, auditLogVM, currentEntity?.auditLogIncident])

    const handClose = useCallback(() => {
        auditLogVM.onCloseDetailPanel();
    }, [auditLogVM]);

    return <>
        <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
            <Sidebarheader style={{ width: '100%' }}>
                <Breadcrumb>
                    <HPHBreadcrumb breadcrumbData={[{ title: SCREEN_CONSTANT.CATEGORY },
                    { title: SCREEN_CONSTANT.TITLE }]} onCurrentClick={() => { }}>
                    </HPHBreadcrumb>
                </Breadcrumb>
                <StyledAction>
                    <>
                        <IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement='bottom' toolTipText={'Close'} onClick={() => handClose()} />
                    </>
                </StyledAction>
            </Sidebarheader>

            <div className={'add-edit-form'} style={{ height: 'calc(100vh - 125px)', maxHeight: 'calc(100vh - 125px)', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        {(currentEntity.auditLogType === 'Line Charge Related' || currentEntity.auditLogType === 'Counter Charge Related') &&
                            <>
                                <CriteriaItemContainer>
                                    {memoUpdatedDateTime}
                                    {memoCntrNo}
                                    {memoChargeType}
                                    {memoSubChargeType}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoOpsLine}
                                    {memoProposalNo}
                                    {memoUserId}
                                    {memoBillOfLading}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoShippingBill}
                                    {memoForwarderCode}
                                    {memoDtlStateBf}
                                    {memoDtlStateAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoBillToCompanyBf}
                                    {memoBillToCompanyAf}
                                    {memoChargeOnCompanyBf}
                                    {memoChargeOnCompanyAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoAuditLogIncident}
                                </CriteriaItemContainer>
                            </>
                        }
                        {(currentEntity.auditLogType === 'Waiver Related') &&
                            <>
                                <CriteriaItemContainer>
                                    {memoUpdatedDateTime}
                                    {memoCntrNo}
                                    {memoChargeType}
                                    {memoSubChargeType}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoOpsLine}
                                    {memoProposalNo}
                                    {memoUserId}
                                    {memoBillOfLading}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoShippingBill}
                                    {memoForwarderCode}
                                    {memoDtlStateBf}
                                    {memoDtlStateAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoAuditLogIncident}
                                </CriteriaItemContainer>
                            </>
                        }
                        {(currentEntity.auditLogType === 'Collection Related') &&
                            <>
                                <CriteriaItemContainer>
                                    {memoUpdatedDateTime}
                                    {memoUserId}
                                    {memoDraftDocNoBf}
                                    {memoDraftDocNoAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoDocNoBf}
                                    {memoDocNoAf}
                                    {memoReceiptNoBf}
                                    {memoReceiptNoAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoAuditLogIncident}
                                </CriteriaItemContainer>
                            </>
                        }
                        {(currentEntity.auditLogType === 'Maintenance Related') &&
                            <>
                                <CriteriaItemContainer>
                                    {memoUpdatedDateTime}
                                    {memoUserId}
                                    {memoConsortiumCodeAf}
                                    {memoVesselCodeAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoVoyageCodeAf}
                                    {memoFspCalculateMethodAf}
                                    {memoCompanyCodeBf}
                                    {memoCompanyCodeAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoPriorityBf}
                                    {memoPriorityAf}
                                    {memoStatusBf}
                                    {memoStatusAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoOwnerBf}
                                    {memoOwnerAf}
                                    {memoEffectiveDateFromBf}
                                    {memoEffectiveDateFromAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoEffectiveDateToBf}
                                    {memoEffectiveDateToAf}
                                    {memoServiceCodeBf}
                                    {memoServiceCodeAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoForwarderCodeBf}
                                    {memoForwarderCodeAf}
                                    {memoAgentCodeBf}
                                    {memoAgentCodeAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoCargoCodeBf}
                                    {memoCargoCodeAf}
                                    {memoFspCountingFromBf}
                                    {memoFspCountingFromAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memofspCountingToBf}
                                    {memofspCountingToAf}
                                    {memoGraceHourFromBf}
                                    {memoGraceHourFromAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoGraceHourToBf}
                                    {memoGraceHourToAf}
                                    {memoGraceMinuteFromBf}
                                    {memoGraceMinuteFromAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoGraceMinuteToBf}
                                    {memoGraceMinuteToAf}
                                    {memoShipmentTypeBf}
                                    {memoShipmentTypeAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoFspCountingDirectionBf}
                                    {memoFspCountingDirectionAf}
                                    {memoFirstTierFspBf}
                                    {memoFirstTierFspAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoFspUomBf}
                                    {memoFspUomAf}
                                    {memoChargeTypeBf}
                                    {memoChargeTypeAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoSubChargeTypeBf}
                                    {memoSubChargeTypeAf}
                                    {memoCntrMovementBf}
                                    {memoCntrMovementAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoCntrStatusBf}
                                    {memoCntrStatusAf}
                                    {memoCustomerTypeBf}
                                    {memoCustomerTypeAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoForwarderReferenceBf}
                                    {memoForwarderReferenceAf}
                                    {memoApplyCalendarAdjBf}
                                    {memoApplyCalendarAdjAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoSplitFirstDaysBf}
                                    {memoSplitFirstDaysAf}
                                    {memoSplitFirstDaysToBf}
                                    {memoSplitFirstDaysToAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoSplitRemainDaysToBf}
                                    {memoSplitRemainDaysToAf}
                                    {memoRejectReasonBf}
                                    {memoRejectReasonAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoRemarksBf}
                                    {memoRemarksAf}
                                    {memoGraceExtendBf}
                                    {memoGraceExtendAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoActiveIndBf}
                                    {memoActiveIndAf}
                                </CriteriaItemContainer>
                                <CriteriaItemContainer>
                                    {memoAuditLogIncident}
                                </CriteriaItemContainer>
                            </>
                        }
                    </div>
                </div>
            </div>
        </StyledSidebar>
    </>
}

export default memo(AuditLogDetailPanel);
